// Firebase initialization for UNION Check
// Web SDK is used ONLY for Analytics. Auth + DB stay on our FastAPI backend.
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported as analyticsSupported, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Only initialize if a real API key is provided (skip during local dev / tests)
const hasConfig = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);

let firebaseApp = null;
let analyticsInstance = null;

if (hasConfig) {
  firebaseApp = initializeApp(firebaseConfig);
  // Analytics only works in browsers that support it (most modern browsers)
  analyticsSupported()
    .then((ok) => {
      if (ok) analyticsInstance = getAnalytics(firebaseApp);
    })
    .catch(() => {
      /* analytics unavailable: ignore */
    });
}

export const trackEvent = (name, params = {}) => {
  if (analyticsInstance) {
    try {
      logEvent(analyticsInstance, name, params);
    } catch {
      /* swallow */
    }
  }
};

export { firebaseApp };
